import VendorBillPage from "./VendorBillPage";

export default function SalaryPaymentPage() {
  return (
    <VendorBillPage
      moduleKey="salary"
      moduleName="salary_payment"
      title="Salary Payment"
      route="salary-payments"
      columns={[
        { field: "month",             label: "Month",             placeholder: "e.g. Apr-26" },
        { field: "manpower_category", label: "Manpower Category", placeholder: "e.g. Skilled / Helper" },
      ]}
    />
  );
}
